import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';

import { getUserFromPing } from '../../api/services/auth/authService';
import { RootState } from '../../store';
import { setUser } from '../../store/auth/authSlice';

export const useUserInfo = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  const dispatch = useDispatch();

  const { data, error, isLoading } = useQuery<any, Error>({
    queryKey: ['userInfo'],
    queryFn: () => {
      if (token) {
        return getUserFromPing(token);
      } else {
        return Promise.reject(new Error('error'));
      }
    },
    enabled: !!token,
  });

  useEffect(() => {
    if (data) {
      const { email, givenName, familyName } = data;
      const userObj = {
        email,
        username: `${givenName} ${familyName}`,
      };
      dispatch(setUser(userObj));
    }
  }, [data, dispatch]);

  return { data, error, isLoading };
};
